export const matchFileType = (fileName) => {
    let suffix = "";
    let result = "";
    try {
        let fileNameList = fileName.split(".");
        suffix = fileNameList[fileNameList.length - 1];
    }
    catch (err) {
        suffix = "";
    }
    if (!suffix)
        return false;
    let imgList = ["png", "jpg", "jpeg", "bmp", "fig"];
    if (imgList.includes(suffix)) {
        return "img";
    }
    switch (suffix) {
        case "ppt":
            result = "pptx";
            break;
        case "pptx":
            result = "pptx";
            break;
        case "doc":
            result = "word";
            break;
        case "docx":
            result = "word";
            break;
        case "xlsx":
            result = "excel";
            break;
        case "pdf":
            result = "pdf";
            break;
        default:
            result = "default";
            break;
    }
    return result;
};
export const previewAttach = (type, url) => {
    console.log(window);
    const host = window.location.protocol + "//" + window.location.host;
    if (type === "img") {
    }
    else if (["pptx", "word", "excel"].includes(type)) {
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    }
    else if (["pdf"].includes(type)) {
        window.open(`${host}/generic/web/viewer.html?file=${url}`);
    }
};
